import { PORTFOLIO_CONTRACT_STATE } from "web_myplann/Portfolio/Components/Redesign/Filter/portfolioContractState";
import type { AvailableCategoriesByContractState } from "web_myplann/Portfolio/Types/AvailableCategoriesByContractState";

export const hasArchivedItems = (
	availableByContractState: AvailableCategoriesByContractState | undefined,
): boolean =>
	(availableByContractState?.[PORTFOLIO_CONTRACT_STATE.archived].length ?? 0) >
	0;
